import { applyFormat } from './applyFormat';
import { resolveFormatSpec } from './resolveFormatSpec';
const POSITIONAL_PLACEHOLDER_PATTERN = /\{\{(\d+)\}\}/g;
function resolveLoopItemField(item, field) {
  return typeof item === 'object' && item !== null ? item[field] : undefined;
}
function resolveVariableSource(key, namespaces, loopItem) {
  const dot = key.indexOf('.');
  if (dot === -1) {
    if (loopItem && key === loopItem.itemAlias) return loopItem.item;
    return namespaces.context[key];
  }
  const nsName = key.slice(0, dot);
  const field = key.slice(dot + 1);
  if (nsName === 'context') return namespaces.context[field];
  if (nsName === 'system') return namespaces.system[field];
  if (loopItem && nsName === loopItem.itemAlias) return resolveLoopItemField(loopItem.item, field);
  return undefined;
}
function formatVariableValue(value, variable, namespaces, loopItem) {
  if (variable.format) {
    const resolvedFormat = resolveFormatSpec(variable.format, namespaces, loopItem);
    if (resolvedFormat) {
      return applyFormat(value, resolvedFormat, namespaces.system.locale);
    }
  }
  if (value === undefined || value === null) return '';
  return String(value);
}
function substitutePositionalVariables(entry, namespaces, loopItem) {
  var _entry$variables;
  const variables = (_entry$variables = entry.variables) !== null && _entry$variables !== void 0 ? _entry$variables : [];
  const formattedValues = variables.map(variable => formatVariableValue(resolveVariableSource(variable.key, namespaces, loopItem), variable, namespaces, loopItem));
  return entry.text.replace(POSITIONAL_PLACEHOLDER_PATTERN, (match, indexText) => {
    const index = Number(indexText);
    if (!Number.isInteger(index) || index < 0 || index >= formattedValues.length) {
      return match;
    }
    return formattedValues[index];
  });
}
function resolveAllDynamicText(namespaces, loopItem) {
  return Object.fromEntries(Object.entries(namespaces.text).map(([key, entry]) => [key, substitutePositionalVariables(entry, namespaces, loopItem)]));
}
export function resolvePath(path, namespaces, loopItem) {
  if (path === 'text') return resolveAllDynamicText(namespaces, loopItem);
  const dot = path.indexOf('.');
  if (dot === -1) {
    if (loopItem && path === loopItem.itemAlias) return loopItem.item;
    return undefined;
  }
  const nsName = path.slice(0, dot);
  const key = path.slice(dot + 1);
  if (nsName === 'context') return namespaces.context[key];
  if (nsName === 'system') return namespaces.system[key];
  if (nsName === 'text') {
    const entry = namespaces.text[key];
    return entry !== undefined ? substitutePositionalVariables(entry, namespaces, loopItem) : undefined;
  }
  if (loopItem && nsName === loopItem.itemAlias) return resolveLoopItemField(loopItem.item, key);
  return undefined;
}